export default __webpack_public_path__ + "static/media/events.fbf56d18.svg";